module.exports = __webpack_public_path__ + "static/media/Upgrade_Downgrade.eac31458.svg";